const Plus = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 5.5V0.5H5V5.5H0V6.5H5V11.5H6V6.5H11V5.5H6Z"
                fill="#1D1D1B"
            />
        </svg>
    )
}

export default Plus
